import { jsxs, jsx } from 'react/jsx-runtime';

function ThickLinkIcon({
  size,
  color = "currentColor",
  ...svgProps
}) {
  return /*#__PURE__*/jsxs("svg", {
    ...svgProps,
    ref: svgProps.ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 13",
    style: {
      ...svgProps.style,
      width: `${size.toString()}px`,
      height: `${size.toString()}px`
    },
    fill: "none",
    stroke: color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [/*#__PURE__*/jsx("path", {
      d: "m6.21559 10.581-.54859.5693c-.24607.2553-.53819.4579-.8597.5961-.3215.1382-.66608.2093-1.01407.2093-.348 0-.69258-.0711-1.01408-.2093-.32151-.1382-.61363-.3408-.8597-.5961-.24606-.2554-.44126-.5585-.57443-.8921-.13317-.33365-.20171-.69123-.20171-1.05234 0-.36112.06854-.71869.20171-1.05232.13317-.33362.32837-.63676.57443-.89211L4.73097 4.3439c.47124-.48925 1.10288-.77621 1.76896-.80365.66608-.02744 1.31766.20666 1.82479.65561.50714.44895.83257 1.07976.91141 1.76664"
    }), /*#__PURE__*/jsx("path", {
      d: "m9.99854 2.44531.44366-.45826c.2461-.25535.5382-.4579.8597-.59609.3215-.13819.6661-.20932 1.0141-.20932s.6926.07113 1.0141.20932.6136.34074.8597.59609c.246.25534.4412.55848.5744.89211.1332.33362.2017.6912.2017 1.05231 0 .36112-.0685.7187-.2017 1.05232-.1332.33363-.3284.63677-.5744.89211l-2.8116 2.91753c-.4714.48819-1.1028.77422-1.76831.80115-.66553.02693-1.31642-.20722-1.82309-.65583-.50667-.44861-.83195-1.07878-.91107-1.76503"
    })]
  });
}

export { ThickLinkIcon };
//# sourceMappingURL=LinkIcon.thick.js.map
